import { useTranslation } from 'react-i18next';
import type { StocktakeStatus } from '@optiflow/types';
import { Badge } from '@/components/ui/Badge';

const TONES: Record<StocktakeStatus, 'brand' | 'success' | 'danger'> = {
  OPEN: 'brand',
  POSTED: 'success',
  CANCELLED: 'danger',
};

export function StocktakeStatusBadge({ status }: { status: StocktakeStatus }) {
  const { t } = useTranslation();

  return <Badge tone={TONES[status]}>{t(`inventory.stocktake.status.${status}`)}</Badge>;
}
